import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type {
  VisibilityEffect,
  StylingEffect,
  Effect,
  RelaxationObstacleEffect,
  ScalingEffect,
} from "building-types/views/effectTypes";
import { EffectType } from "building-types/views/effectTypes";
import type { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";

export function visibilityEffectNew({
  name = "Visibility Effect",
  categories = [],
  parentId,
  invert,
}: Partial<VisibilityEffect> = {}): VisibilityEffect {
  return {
    ...docEntityBaseNew("EFFECT"),
    type: EffectType.VISIBILITY,
    name,
    categories,
    invert,
    parentId,
  };
}

export function stylingEffectNew({
  name = "Styling Effect",
  categories = [],
  textStyleOverrides = {},
  lineStyleOverrides = {},
  parentId,
}: Partial<StylingEffect> = {}): StylingEffect {
  return {
    ...docEntityBaseNew("EFFECT"),
    type: EffectType.STYLING,
    name,
    categories,
    textStyleOverrides,
    lineStyleOverrides,
    parentId,
  };
}

export function scalingEffectNew({
  name = "Scaling Effect",
  categories = [],
  scale = 1,
  parentId,
}: Partial<ScalingEffect> = {}): ScalingEffect {
  return {
    ...docEntityBaseNew("EFFECT"),
    type: EffectType.SCALING,
    name,
    categories,
    scale,
    parentId,
  };
}

export function relaxationObstacleEffectNew({
  name = "Relaxation Obstacle Effect",
  categories = [],
  parentId,
}: Partial<RelaxationObstacleEffect> = {}): RelaxationObstacleEffect {
  return {
    ...docEntityBaseNew("EFFECT"),
    type: EffectType.RELAXATION_OBSTACLE,
    targetCategory: null,
    name,
    categories,
    parentId,
  };
}

export function effectContainsCategory(effect: Effect, category: SheetGeometryCategory): boolean {
  return effect.categories.length === 0 || effect.categories.includes(category);
}

export function isVisibilityEffect(effect: Effect): effect is VisibilityEffect {
  return effect.type === EffectType.VISIBILITY;
}

export function isStylingEffect(effect: Effect): effect is StylingEffect {
  return effect.type === EffectType.STYLING;
}

export function isScalingEffect(effect: Effect): effect is ScalingEffect {
  return effect.type === EffectType.SCALING;
}

export function isRelaxationObstacleEffect(effect: Effect): effect is RelaxationObstacleEffect {
  return effect.type === EffectType.RELAXATION_OBSTACLE;
}
